import { render, staticRenderFns } from "./ip-blacklist.vue?vue&type=template&id=529e46b5&"
import script from "./ip-blacklist.vue?vue&type=script&lang=js&"
export * from "./ip-blacklist.vue?vue&type=script&lang=js&"
import style0 from "./ip-blacklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports